import { createContext } from 'react';
import { IUserRoles } from '../models';

type PermissionsContextType = {
    permissions?: IUserRoles[];
};

export const PermissionsContext = createContext<PermissionsContextType>({});
